/* Story whales: a quiet hug on tap (or Enter/Space).
   Uses the separate translate/rotate/scale properties so it adds to the idle swim (which uses transform)
   instead of replacing it: the swim keeps running underneath and the whales ease back without a jump.
   Drawing is scaled ~1/3, so 12 units is about 4px on screen. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = 'cubic-bezier(.45, 0, .25, 1)';
  function wave(el, peak, opts) {
    if (!el || !el.animate) return null;
    var rest = {};
    Object.keys(peak).forEach(function (k) { rest[k] = k === 'scale' ? '1' : (k === 'rotate' ? '0deg' : '0px 0px'); });
    var a = Object.assign({}, rest, { easing: ease });
    var b = Object.assign({}, peak, { offset: opts.peakAt || 0.45, easing: ease });
    var c = Object.assign({}, rest);
    return el.animate([a, b, c], { duration: opts.duration || 1400, delay: opts.delay || 0, fill: 'none' });
  }
  function hug(art) {
    if (art.__busy || reduce) return;
    art.__busy = true;
    var runs = [
      wave(art.querySelector('.tide-whale__mom'),   { translate: '12px 0px', rotate: '1deg' },  { duration: 1400 }),
      wave(art.querySelector('.tide-whale__calf'),  { translate: '0px -14px', rotate: '-2deg' }, { duration: 1400, delay: 90, peakAt: 0.42 }),
      wave(art.querySelector('.tide-whale__heart'), { scale: '1.16' },                           { duration: 1300, delay: 140, peakAt: 0.4 })
    ].filter(Boolean);
    var done = function () { art.__busy = false; };
    if (runs.length && runs[0].finished) Promise.all(runs.map(function (r) { return r.finished; })).then(done, done);
    else setTimeout(done, 1600);
  }
  function init(root) {
    (root || document).querySelectorAll('.tide-story__art').forEach(function (art) {
      if (art.__hug) return;
      art.__hug = true;
      art.setAttribute('role', 'button');
      art.setAttribute('tabindex', '0');
      art.setAttribute('aria-label', 'Give the whales a hug');
      art.addEventListener('click', function () { hug(art); });
      art.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); hug(art); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
